import { render, staticRenderFns } from "./ServiceReviewDetails.vue?vue&type=template&id=4ecda974&scoped=true&"
import script from "./ServiceReviewDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceReviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceReviewDetails.vue?vue&type=style&index=0&id=4ecda974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecda974",
  null
  
)

export default component.exports